import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "handlebar-filters" }

import { ref } from 'vue'
import { BfFlex } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { useHandlebarStore } from '@/store/handlebarStore'
import { useBikeStore } from '@/store/bikeStore'
import handlebarService from '@/service/handlebarService'
import type {
  CommonCheckFilterType,
  CommonSliderFilterType,
} from '@/types/filter'
import { BikeHoodsType } from '@/types/bike'
import FilterSummary from '@/components/setup/FilterSummary.vue'
import FilterSummaryItem from '@/components/setup/FilterSummaryItem.vue'
import CommonFilterAccordion from '@/components/setup/common/CommonFilterAccordion.vue'
import CommonCheckFilters from '@/components/setup/common/CommonCheckFilters.vue'
import CommonSliderFilter from '@/components/setup/common/CommonSliderFilter.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HandlebarFilters',
  setup(__props) {

const { t } = useI18n()

const userStore = useUserStore()
const { sessionId } = storeToRefs(userStore)

const handlebarStore = useHandlebarStore()
const { filters } = storeToRefs(handlebarStore)

const bikeStore = useBikeStore()
const { bikeHoodsType } = storeToRefs(bikeStore)

const typeSummary = ref()
const widthSummary = ref()
const reachSummary = ref()
const dropSummary = ref()
const sweepSummary = ref()
const flareSummary = ref()

const loading = ref(false)

const widthIcon = () => {
  return handlebarService.getWidthIcon(bikeHoodsType.value)
}

const sweepIcon = () => {
  return handlebarService.getSweepIcon(bikeHoodsType.value)
}

const handlebarTypeFilters: CommonCheckFilterType = {
  TypeRoad: {
    label: t('common.bike.type.road'),
    icons: {
      default: '/icons/filters/bike__road.svg',
      selected: '/icons/filters/bike__road--selected.svg',
    },
  },
  TypeGravel: {
    label: t('common.bike.type.gravel'),
    icons: {
      default: '/icons/filters/bike__gravel.svg',
      selected: '/icons/filters/bike__gravel--selected.svg',
    },
  },
  TypeCyclocross: {
    label: t('common.bike.type.cyclocross'),
    icons: {
      default: '/icons/filters/bike__cyclocross.svg',
      selected: '/icons/filters/bike__cyclocross--selected.svg',
    },
  },
  TypeTimeTrial: {
    label: t('common.bike.type.timeTrial'),
    icons: {
      default: '/icons/filters/bike__time-trial.svg',
      selected: '/icons/filters/bike__time-trial--selected.svg',
    },
  },
  TypeFullTriathlon: {
    label: t('common.bike.type.fullTriathlon'),
    icons: {
      default: '/icons/filters/bike__trifull.svg',
      selected: '/icons/filters/bike__trifull--selected.svg',
    },
  },
  TypeShortTriathlon: {
    label: t('common.bike.type.shortTriathlon'),
    icons: {
      default: '/icons/filters/bike__trishort.svg',
      selected: '/icons/filters/bike__trishort--selected.svg',
    },
  },
  TypeMtbCrossCountry: {
    label: t('common.bike.type.mtbCrossCountry'),
    icons: {
      default: '/icons/filters/bike__mtb-cx.svg',
      selected: '/icons/filters/bike__mtb-cx--selected.svg',
    },
  },
  TypeMtbTrail: {
    label: t('common.bike.type.mtbTrail'),
    icons: {
      default: '/icons/filters/bike__mtb-trial.svg',
      selected: '/icons/filters/bike__mtb-trial--selected.svg',
    },
  },
  TypeTrekking: {
    label: t('common.bike.type.trekking'),
    icons: {
      default: '/icons/filters/bike__trekking.svg',
      selected: '/icons/filters/bike__trekking--selected.svg',
    },
  },
  TypeCity: {
    label: t('common.bike.type.city'),
    icons: {
      default: '/icons/filters/bike__city.svg',
      selected: '/icons/filters/bike__city--selected.svg',
    },
  },
}

const handlebarWidthFilter: CommonSliderFilterType = {
  value: {
    Width: filters.value.Width ?? 300,
  },
  min: {
    MinWidth: 300,
  },
  max: {
    MaxWidth: 1000,
  },
}

const handlebarReachFilter: CommonSliderFilterType = {
  value: {
    Reach: filters.value.Reach ?? 0,
  },
  min: {
    MinReach: 0,
  },
  max: {
    MaxReach: 200,
  },
}

const handlebarDropFilter: CommonSliderFilterType = {
  value: {
    Drop: filters.value.Drop ?? 0,
  },
  min: {
    MinDrop: 0,
  },
  max: {
    MaxDrop: 200,
  },
}

const handlebarSweepFilter: CommonSliderFilterType = {
  value: {
    Sweep: filters.value.Sweep ?? 0,
  },
  min: {
    MinSweep: 0,
  },
  max: {
    MaxSweep: 45,
  },
}

const handlebarFlareFilter: CommonSliderFilterType = {
  value: {
    Flare: filters.value.Flare ?? 0,
  },
  min: {
    MinFlare: 0,
  },
  max: {
    MaxFlare: 36,
  },
}

const search = (e?: Record<string, any>) => {
  handlebarStore.reset()

  if (e) handlebarStore.setFilters(e)

  handlebarStore.retrieveHandlebars(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_unref(t)('common.properties')), 1),
    _createVNode(_unref(BfFlex), { direction: "column" }, {
      default: _withCtx(() => [
        _createVNode(CommonFilterAccordion, {
          title: _unref(t)('setup.handlebar.bike'),
          icon: "/icons/filters/bike.svg"
        }, {
          default: _withCtx(() => [
            _createVNode(CommonCheckFilters, {
              filters: handlebarTypeFilters,
              onUpdated: _cache[0] || (_cache[0] = ($event: any) => (search($event))),
              onSummary: _cache[1] || (_cache[1] = ($event: any) => (typeSummary.value = $event))
            })
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(CommonFilterAccordion, {
          title: _unref(t)('setup.handlebar.width'),
          icon: widthIcon()
        }, {
          default: _withCtx(() => [
            _createVNode(CommonSliderFilter, {
              unit: _unref(t)('common.unit.mm'),
              "summary-prefix": _unref(t)('setup.handlebar.width'),
              filter: handlebarWidthFilter,
              onUpdated: _cache[2] || (_cache[2] = ($event: any) => (search($event))),
              onSummary: _cache[3] || (_cache[3] = ($event: any) => (widthSummary.value = $event))
            }, null, 8, ["unit", "summary-prefix"])
          ]),
          _: 1
        }, 8, ["title", "icon"]),
        (_unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR)
          ? (_openBlock(), _createBlock(CommonFilterAccordion, {
              key: 0,
              title: _unref(t)('setup.handlebar.reach'),
              icon: "/icons/filters/handlebar__road--reach.svg"
            }, {
              default: _withCtx(() => [
                _createVNode(CommonSliderFilter, {
                  unit: _unref(t)('common.unit.mm'),
                  "summary-prefix": _unref(t)('setup.handlebar.reach'),
                  filter: handlebarReachFilter,
                  onUpdated: _cache[4] || (_cache[4] = ($event: any) => (search($event))),
                  onSummary: _cache[5] || (_cache[5] = ($event: any) => (reachSummary.value = $event))
                }, null, 8, ["unit", "summary-prefix"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (_unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR)
          ? (_openBlock(), _createBlock(CommonFilterAccordion, {
              key: 1,
              title: _unref(t)('setup.handlebar.drop'),
              icon: "/icons/filters/handlebar__road--drop.svg"
            }, {
              default: _withCtx(() => [
                _createVNode(CommonSliderFilter, {
                  unit: _unref(t)('common.unit.mm'),
                  "summary-prefix": _unref(t)('setup.handlebar.drop'),
                  filter: handlebarDropFilter,
                  onUpdated: _cache[6] || (_cache[6] = ($event: any) => (search($event))),
                  onSummary: _cache[7] || (_cache[7] = ($event: any) => (dropSummary.value = $event))
                }, null, 8, ["unit", "summary-prefix"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (
          _unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR ||
          _unref(bikeHoodsType) === _unref(BikeHoodsType).FLATBAR
        )
          ? (_openBlock(), _createBlock(CommonFilterAccordion, {
              key: 2,
              title: _unref(t)('setup.handlebar.sweep'),
              icon: sweepIcon()
            }, {
              default: _withCtx(() => [
                _createVNode(CommonSliderFilter, {
                  unit: _unref(t)('common.unit.degreesSign'),
                  "summary-prefix": _unref(t)('setup.handlebar.sweep'),
                  filter: handlebarSweepFilter,
                  onUpdated: _cache[8] || (_cache[8] = ($event: any) => (search($event))),
                  onSummary: _cache[9] || (_cache[9] = ($event: any) => (sweepSummary.value = $event))
                }, null, 8, ["unit", "summary-prefix"])
              ]),
              _: 1
            }, 8, ["title", "icon"]))
          : _createCommentVNode("", true),
        (_unref(bikeHoodsType) === _unref(BikeHoodsType).DROPBAR)
          ? (_openBlock(), _createBlock(CommonFilterAccordion, {
              key: 3,
              title: _unref(t)('setup.handlebar.flare'),
              icon: "/icons/filters/handlebar__road--flare.svg"
            }, {
              default: _withCtx(() => [
                _createVNode(CommonSliderFilter, {
                  unit: _unref(t)('common.unit.degreesSign'),
                  "summary-prefix": _unref(t)('setup.handlebar.flare'),
                  filter: handlebarFlareFilter,
                  onUpdated: _cache[10] || (_cache[10] = ($event: any) => (search($event))),
                  onSummary: _cache[11] || (_cache[11] = ($event: any) => (sweepSummary.value = $event))
                }, null, 8, ["unit", "summary-prefix"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(FilterSummary, null, {
      default: _withCtx(() => [
        (typeSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(typeSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (widthSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(widthSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (reachSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 2 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(reachSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (dropSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 3 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(dropSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (sweepSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 4 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(sweepSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (flareSummary.value)
          ? (_openBlock(), _createBlock(FilterSummaryItem, { key: 5 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(flareSummary.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})